import {
  Badge,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableRow,
} from '@material-ui/core'
import { useState } from 'react'

const TicketDetailDialog = ({ ticket, process, publicUrl }) => {
  const [openTicketId, setOpenTicketId] = useState()

  return (
    <>
      <Grid
        item
        style={{
          marginLeft: 'auto',
          cursor: 'pointer',
        }}
        onClick={() => {
          setOpenTicketId(ticket.id)
        }}
      >
        <Badge
          style={{
            backgroundColor: '#143A5F',
            borderRadius: '1rem',
            padding: '2px',
          }}
        >
          <svg
            focusable="false"
            aria-hidden="true"
            viewBox="0 0 24 24"
            style={{ width: '15px', fill: 'white' }}
          >
            <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"></path>
          </svg>
        </Badge>
      </Grid>
      <Dialog
        open={openTicketId === ticket.id}
        onClose={() => {
          setOpenTicketId(null)
        }}
        maxWidth="md"
      >
        <DialogTitle>Détail du ticket</DialogTitle>
        <DialogContent>
          <Grid container>
            <Grid
              item
              md={7}
              style={{
                marginBottom: '16px',
              }}
            >
              <Table>
                <TableBody>
                  <TableRow>
                    <TableCell>Ticket n° :</TableCell>
                    <TableCell>{ticket.id}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Thématique :</TableCell>
                    <TableCell>{process.name}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Prestataire :</TableCell>
                    <TableCell>{ticket.providers}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Demande :</TableCell>
                    <TableCell>{ticket.created}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Dernière action :</TableCell>
                    <TableCell>{ticket.last_state_change}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colspan={2}>
                      Si des fichiers ont été joints à la demande ou proposés
                      par le prestataire, vous les trouverez en cliquant sur la
                      petite icône "fichiers" associée au ticket, sur le plan
                      d'action.
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </Grid>
            <Grid item xs={12} sm={5}>
              <img
                style={{
                  width: '100%',
                }}
                src={`${publicUrl}/img/ext_coprosummary_modal.svg`}
              />
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </>
  )
}
export default TicketDetailDialog
